import { createContext, type FC, type ReactNode } from "react";
import type { LastBotCore } from "../core/LastBotCore";

export const CoreContext = createContext<LastBotCore | null>(null);

interface CoreProviderProps {
  core: LastBotCore;
  children: ReactNode;
}

export const CoreProvider: FC<CoreProviderProps> = ({ core, children }) => (
  <CoreContext.Provider value={core}>{children}</CoreContext.Provider>
);
